import { useQuery, useMutation } from "@tanstack/react-query";
import { NotificationType } from "enums";
import { ApiResponseType } from "enums";
import { printError, useSearch, useUtilities } from "helpers";
import {
  getAllEnvironments,
  updateEnvironment,
} from "api/siteSettings/environments";
import { useEffect } from "react";
import {
  setEnvironmentsAction,
  updateEnvironmentAction,
} from "redux/reducers/siteSettings/environments";
import { t } from "i18next";

export function useGetAllEnvironments() {
  const { web = null } = useSearch();
  return useQuery(["environmentList", web], () => getAllEnvironments(web));
}

export function useEnvironments() {
  const { web = null } = useSearch();
  const { data, isLoading, error } = useGetAllEnvironments();
  const {
    dispatch,
    environments: { environments, loaded, website_id },
  } = useUtilities();

  useEffect(() => {
    if (data && (!loaded || website_id !== web)) {
      dispatch(setEnvironmentsAction({
        environments: data.data,
        website_id: web,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error, loaded, web, website_id]);

  return {
    data: environments,
    isLoading: isLoading || !loaded || website_id !== web,
    error,
  };
}

export function useUpdateEnvironment() {
  const { notification, dispatch } = useUtilities();
  return useMutation(updateEnvironment, {
    onSuccess: (data) => {
      if (data.status_code === ApiResponseType.SUCCESS) {
        dispatch(updateEnvironmentAction(data.data));
        notification({
          type: NotificationType.SUCCESS,
          message: t("siteSetting.environments.api.notification.updated"),
        });
      } else {
        notification({
          type: NotificationType.ERROR,
          message: printError(data.message),
        });
      }
    },
    onError: (err) => {
      notification({
        type: NotificationType.ERROR,
        message: printError(err.message),
      });
    },
  });
}
